<template>
  <div v-if="loading.Data" class="m-auto" style="height: 700px">
    <spinner-loading ></spinner-loading>
  </div>
  <div v-else class="h-100 w-100" id="summary"> 
    <b-row>
      <b-col>
        <!-- bcrm_display_chart_1 -->
        <b-row class="d-flex align-items-stretch align-self-stretch" v-for="(row, index) in summaryDisplay.chartList" :key="`row-${index}`">
          <b-col class="flex-stretch fixcard" v-for="(group, i) in row.g_row_group" :key="`group-${i}`" :cols="group.g_col">
            <b-row class="h-100">
              <b-col class="flex-wrap" v-for="(card, k) in group.sub_row_group" :key="`card-${k}`" :cols="card.sub_col">
                <b-card no-body class="data-table-card p-relative w-100">
                  <component
                    :is="renderCardByType(card.card_type)"
                    :keyid="card"
                    :dynamicTableConfig="dynamicTableConfig"
                    :BrandAppDetail="BrandAppDetail"
                  />
                </b-card>
              </b-col> 
            </b-row> 
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { BCard, BRow, BCol } from 'bootstrap-vue';
  import vSelect from 'vue-select';
  import Ripple from 'vue-ripple-directive';  
  import OverallCard from '../data-management-list/components/bi-card/OverallCard.vue';
  import ChartCard from '../data-management-list/components/bi-card/ChartCard.vue';
  import PieChartCard from './bi-card/PieChartCard.vue'
  import MultiOverallCard from './bi-card/MultiOverallCard.vue'
  import DataTableCard from './bi-card/DataTableCard.vue'
  import GenderCard from './bi-card/GenderCard.vue'

  import userDataManagementSummary from './hooks/userDataManagementSummary';

  export default {
    directives: {
      Ripple,
    },
    components: {
      BCard,
      BRow,
      BCol,
      vSelect,
      MultiOverallCard,
      OverallCard,
      ChartCard,
      PieChartCard,
      DataTableCard,
      GenderCard,
    },
    setup() {

      const renderCardByType = (type) => {
        switch (type) {
          case 1:
            return MultiOverallCard;
          case 2:
            return PieChartCard;
          case 3:
            return GenderCard;
          case 4:
            return DataTableCard;
          default:
            break;
        }
      };

      const {
        loading,
        summaryDisplay,
        dynamicTableConfig,
        DynamicUI,
        BrandAppDetail
      } = userDataManagementSummary();

      return {
        loading,
        summaryDisplay,
        dynamicTableConfig,
        DynamicUI,
        BrandAppDetail,
        renderCardByType
      };
    },
  }
</script>

<style>
  @import '~@/assets/css/pages/data-management.css';

#summary .flex-stretch {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
}

#summary .flex-wrap {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

#summary .fixcard {
  min-height: 500px;
}
</style>

<style scoped>
  .loading-data-tr{
     height: 45%;
  }

  .data-table-card{
    height: 100%;
    border-radius : 1.428rem;
  }
</style>

